import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      display: ['contents', 'none'],
    };

    this.heading = {
      variant: 'text.h1',
      px: 8,
      my: 10,
    };

    this.grid = {
      gridTemplateColumns: '1fr',
      gridGap: 0,
      borderTop: (t) => `1px solid ${t.colors.gray}`,
    };

    this.button = {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      position: 'relative',
      height: '52px',
      p: 8,
      border: (t) => `1px solid ${t.colors.black}`,
      borderRadius: '50px'
    };

    this.sticky = {
      top: ['var(--header-height)', '0'],
      position: 'sticky',
      bg: 'white',
      zIndex: 2,
      px: 8,
      py: 4,
      mt: 4,
    };

    this.title = {
      variant: 'text.label.1',
      display: 'inline-block',
    };

    this.selectedSort = {
      fontSize: 3,
      color: 'mediumDarkGray',
      ml: 4,
    };

    this.icon = {
      position: 'absolute',
      right: 8,
      top: '50%',
      width: '24px',
      height: '24px',
      transform: 'translateY(-50%)',
    };
  })()
);
